import { useQuery } from '@tanstack/react-query';
import { activitiesService } from '../services/activities.service';

export function useActivities(leadId: number | null) {
  return useQuery({
    queryKey: ['activities', leadId],
    queryFn: () => activitiesService.list(leadId!),
    enabled: !!leadId,
    staleTime: 10000,
  });
}
